app.controller("AgentSalesSearchController",
	["$scope", "$http", function($scope, $http) {
		var key = '';
		var last = 12;
		$scope.soldProperties = [];
		$scope.loading = false;

		$scope.$watch('agentKey', function(){
        	key = $scope.agentKey;
			load();
    	});

		/* $scope.LoadNext = function() {
			skip = skip + limit;
			load();
		};
		$scope.LoadPrev = function() {
			skip = skip - limit;
			load();
		}; */

		function load() {
			$scope.loading = true;
			// skip = Math.max(0, skip);

			$http({
				method: "GET",
				url: "/api/km/KM/sales",
				params: {
					agentKey: key,
					onlineOffer: 'all',
					last: last,
					limit: 12
				}
			})
			.then(function(result) {
				for (var i = 0, max = result.data.data.results.length; i < max; i++) {
					var formatted = {
						text : result.data.data.results[i].lotAreaType.replace(/[0-9]+/, '').toLowerCase(),
						num: result.data.data.results[i].lotAreaType.replace(/[^0-9]+/, '')
					};

					result.data.data.results[i].lotAreaType = formatted;
				}
				
				if (result.data.data.results.length > 0) {
					$scope.soldProperties = result.data.data.results;
				}/*  else {
					skip = skip - limit;
				} */
				$scope.loading = false;
			}, 
			function(result) {
				$scope.loading = false;
			});
		}
	}]
);